const openedPaymentPage = {
  fawry: {
    title: 'Seu pagamento foi criado!',
    importantMessage: {
      title: 'Importante',
      description: 'Você pode pagar usando o número de referência em qualquer um dos canais ou pontos de venda da Fawry ou pelo aplicativo Fawry. Para evitar o cancelamento do pedido, conclua o processo de pagamento dentro do prazo especificado.',
    },
    orderDetail: {
      expirationDate: 'Data de validade do pagamento:',
      totalAmount: 'Total',
    },
    referenceNumber: {
      title: 'Número de referência',
      copy: 'Copiar',
      copied: 'Copiado!',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'Data de nascimento',
        validationMessage: {
          empty: 'Informe sua data de nascimento',
          invalid: 'Data de nascimento inválida',
          serverError: 'Erro no servidor. Tente novamente mais tarde.',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'Pagamentos com criptomoedas são processados exclusivamente por provedores externos licenciados, não pelo EBANX. As informações dos provedores, incluindo suas respectivas licenças e status regulatório, constam nos ',
    termsAndConditions: 'Termos e Condições',
    disclaimer2: ' aplicáveis.',
    merchantInfo: {
      returnButton: 'Você pode cancelar este pagamento e retornar à página de pagamento para escolher outro método de pagamento.',
      backTo: 'Cancelar e voltar',
    },
  },
};

module.exports = openedPaymentPage;
